<script setup>
import { ElMessage } from "element-plus";
import { onMounted, ref } from "vue";

const props = defineProps({
  mistakeValue: {
    type: Number,
    default: 3
  }
});

const emit = defineEmits(["pass"]);

// 绑定滑块值
let value1 = ref(0);
let movecanvas = ref(null);
let loading = ref(false);

// 保存数据，方便验证失败重绘
let rightX, r1, r2, r1y, r2y, errorX;

// 生成一个随机数 30 - 270之间（不能超出边界）
const random = (min = 31, max = 269) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// 随机图片
const getImgFun = () => {
  const randomImgInd = random(1, 40);
  // 使用动态导入
  return `/verImg/${randomImgInd}.jpg`;
};
let imgurl = getImgFun();
console.log(imgurl);

// 初始化数据
const init = () => {
  loading.value = true;
  // 保存正确的偏移值
  rightX = random();
  // 两个圆的半径
  r1 = random(20, 30);
  r2 = r1 - 5;
  // 随机生成两个圆的y坐标(不能超出边界)
  r1y = random(31, 169);
  r2y = random(31, 169);
  // 生成一个错误的偏移值，值在30-rightX之间，或者rightX - 270之间
  errorX =
    rightX + r1 > 200
      ? random(31, rightX - r1 - r2) // 在30到rightX之间
      : random(rightX + r1 + r2, 269); // 在rightX到270之间
};
init();

// 画:验证图
const dorwVerify = () => {
  const canvas = document.querySelector("#verify");
  const ctx = canvas.getContext("2d");
  const img = new Image();
  img.src = imgurl;
  img.onload = () => {
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    // 在canvas上形成两个浅灰色的圆，并覆盖在图片上
    ctx.beginPath();
    ctx.arc(rightX, r1y, r1, 0, 2 * Math.PI);
    // 获取到rightX点的颜色
    let rgba = getRgba(
      rightX,
      r1y,
      ctx.getImageData(0, 0, canvas.width, canvas.height),
      canvas.width
    );
    let tempcolor = "";
    // 判断该颜色是浅色还是深色
    if (rgba.r > 128 && rgba.g > 128 && rgba.b > 128) {
      // 浅色
      tempcolor = "#555";
    } else {
      // 深色
      tempcolor = "#eee";
    }
    ctx.fillStyle = tempcolor;
    ctx.fill();
    ctx.beginPath();
    ctx.arc(errorX, r2y, r2, 0, 2 * Math.PI);
    ctx.fillStyle = tempcolor;
    ctx.fill();
  };
};

// 画:滑块
const drowMove = () => {
  movecanvas.value = document.querySelector("#move");
  const movectx = movecanvas.value.getContext("2d");
  const moveimg = new Image();
  moveimg.src = imgurl;
  moveimg.onload = () => {
    movecanvas.value.width = moveimg.width;
    movecanvas.value.height = moveimg.height;
    // 创建圆形路径
    movectx.beginPath();
    movectx.arc(rightX, r1y, r1, 0, 2 * Math.PI);
    movectx.closePath();
    // 裁剪画布
    movectx.clip();
    // 只绘制裁剪区域内的图片
    movectx.drawImage(moveimg, 0, 0, movecanvas.value.width, movecanvas.value.height);

    movecanvas.value.style.left = -rightX + r1 + "px";

    loading.value = false;
  };
};

onMounted(() => {
  dorwVerify();
  drowMove();
});

// 移动设置left
const getvalFun = () => {
  const movecanvas = document.querySelector("#move");
  movecanvas.style.left = -rightX + r1 + (value1.value / 100) * 400 + "px";
};

// 验证
const passFun = () => {
  console.log(rightX);
  console.log((value1.value / 100) * 400 - 100 + r1);
  const stopX = (value1.value / 100) * 400 - 100 + r1;
  if (Math.abs(stopX - rightX) < props.mistakeValue) {
    ElMessage.success("验证成功");
    emit("pass");
  } else {
    ElMessage.error("请重新验证");
    value1.value = 0;
    init();
    dorwVerify();
    drowMove();
  }
};

// 刷新
const refreshFun = () => {
  value1.value = 0;
  imgurl = getImgFun();
  init();
  dorwVerify();
  drowMove();
};

// 点击处的 x,y 和 imgdata 的 index 的对应关系
function point2Index(x, y, canvasW) {
  return (x + y * canvasW) * 4;
}
// 获取图片点击地方的rgba值
function getRgba(x, y, imgData, canvasW) {
  const index = point2Index(x, y, canvasW);
  return {
    r: imgData.data[index],
    g: imgData.data[index + 1],
    b: imgData.data[index + 2],
    a: imgData.data[index + 3]
  };
}
</script>

<template>
  <div class="w-[400px]" v-loading="loading">
    <div class="relative">
      <canvas class="absolute h-[200px] w-[300px]" id="move"></canvas>
      <canvas class="ml-[100px] h-[200px] w-[300px]" id="verify"></canvas>
    </div>
    <div>
      <el-slider
        :step="0.1"
        :show-tooltip="false"
        v-model="value1"
        @input="getvalFun"
        @change="passFun"
      />
    </div>
    <div>
      <el-button plain type="primary" @click="refreshFun">看不清，换一张</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
